export const blankArrayOfLength = (length: number) => {
  return Array(length)
    .fill(null)
    .map((_, index) => index);
};
